module.exports = __webpack_public_path__ + "img/jinyafu2.d296459d.jpg";